export const borderRing = {
  ring: 'ring-1 ring-slate-900/10 dark:ring-white/5',
  hoverRing:
    'transition duration-500 hover:ring hover:ring-brand-500 hover:ring-offset-2 dark:ring-offset-slate-900 dark:hover:ring-brand-600',
  focusRing: 'focus:outline-0 focus:ring focus:ring-brand-500',
  brandRing:
    'ring-2 ring-brand-500 ring-offset-2 ring-offset-brand-500/20 dark:ring-offset-slate-900',
}
